<template>
  <div class="content-center">
    <div class="banner">
      <div class="content">
        <div class="banner-title">小橙支付</div>
        <div class="line" />
        <div class="desc">
          提供全场景一站式综合支付解决方案，以“支付+SaaS”助推企业数字化转型，提升经营效率，降低交易成本，助力门店经营快速增长。
        </div>
        <div class="btn-wrap">
          <div
            class="btn"
            @click="openModal"
          >免费试用</div>
        </div>
      </div>
    </div>
    <div class="block-p01">
      <div class="sk-block-title">
        <div class="title">全场景一站式综合支付解决方案</div>
      </div>
      <div class="content-01">
        <img src="@/assets/images/solution/payment-pic-01.png" alt="">
      </div>
    </div>
    <div class="block-p02">
      <div class="sk-block-title">
        <div class="title">数字化服务成为老板生意好帮手</div>
      </div>
      <div class="content-02">
        <img class="item" src="@/assets/images/solution/payment-pic-02.png" alt="">
        <img class="item" src="@/assets/images/solution/payment-pic-03.png" alt="">
        <img class="item" src="@/assets/images/solution/payment-pic-04.png" alt="">
      </div>
    </div>
    <div class="block-p01">
      <div class="sk-block-title">
        <div class="title">交易稳定   资金安全有保障</div>
      </div>
      <div class="content-03">
        <div class="item odd">
          <div class="item-lf">
            <div class="name">轻松收银</div>
            <div class="line" />
            <div class="font">多种收款工具，简单操作，开机即用，主流支付，任意选择，摆脱无现金找零的限制，在线收款，随时到账，安全放心。</div>
          </div>
          <div class="item-ri">
            <img src="@/assets/images/solution/payment-pic-05.png" alt="">
          </div>
        </div>
        <div class="item even">
          <div class="item-ri">
            <img src="@/assets/images/solution/payment-pic-06.png" alt="">
          </div>
          <div class="item-lf">
            <div class="name">便捷支付</div>
            <div class="line" />
            <div class="font">支持线下门店主扫被扫、现金、刷卡，线上 PC、APP、H5、公众号、小程序等多场景全渠道收付款。</div>
          </div>
        </div>
        <div class="item odd">
          <div class="item-lf">
            <div class="name">资金安全</div>
            <div class="line" />
            <div class="font">银行级监管账户，专户专用，为客户提供合适的资金存管银行，保障商家资金安全无忧。</div>
          </div>
          <div class="item-ri">
            <img src="@/assets/images/solution/payment-pic-07.png" alt="">
          </div>
        </div>
        <div class="item even">
          <div class="item-ri">
            <img src="@/assets/images/solution/payment-pic-08.png" alt="">
          </div>
          <div class="item-lf">
            <div class="name">合规交易</div>
            <div class="line" />
            <div class="font">为平台型企业提供收付款、账户管理、资金管理于一体的清算分账合规解决方案，规避二清风险，保障资金流清结算通畅。</div>
          </div>
        </div>
        <div class="item odd">
          <div class="item-lf">
            <div class="name">智能分析</div>
            <div class="line" />
            <div class="font">自动生成财务报表，营业数据精准分析，实时掌握收支情况，快捷对账，线上线下交易业绩了如指掌。</div>
          </div>
          <div class="item-ri">
            <img src="@/assets/images/solution/payment-pic-09.png" alt="">
          </div>
        </div>
        <div class="item even">
          <div class="item-ri">
            <img src="@/assets/images/solution/payment-pic-10.png" alt="">
          </div>
          <div class="item-lf">
            <div class="name">优惠促销</div>
            <div class="line" />
            <div class="font">帮助老板建立消费者客户画像，支持短信群发、优惠券、满减、满返等多类型支付营销，多种促销组合发力，拉新留存有一手。</div>
          </div>
        </div>
      </div>
    </div>
    <CarouselItem title="智能支付" />
    <ConsultForm info-sources="智能支付" title="咨询服务 立即预约" />
    <TryModal v-if="visible" :visible="visible" info-sources="智能支付" @cancel="modalClose" />
  </div>
</template>
<script>
import metaInfo from '@/common/util/metaInfo'
import ConsultForm from '@/components/ConsultForm'
import TryModal from '@/components/TryModal'
import CarouselItem from '@/components/CarouselItem'

export default {
  metaInfo: metaInfo.Payment,
  name: 'Payment',
  components: {
    ConsultForm,
    TryModal,
    CarouselItem
  },
  data: function() {
    return {
      visible: false
    }
  },
  methods: {
    openModal: function() {
      this.visible = true
    },
    modalClose: function(data) {
      this.visible = data
    }
  }
}
</script>
<style lang="less" scoped>
.banner {
  background: url("~@/assets/images/solution/payment_banner.png") no-repeat center;
  background-size: 100% 100%;
  min-width: 1200px;
  .content {
    width: 1200px;
    margin: 0 auto;
    padding: 53px 0;
    text-align: left;
    .banner-title {
      font-size: 48px;
      color: #FFFFFF;
      line-height: 55px;
    }
    .line {
      width: 100px;
      height: 6px;
      background: #28DAFB;
      margin: 16px 0 31px;
    }
    .desc {
      width: 484px;
      height: 101px;
      font-size: 22px;
      color: #FFFFFF;
      line-height: 38px;
    }
    .btn-wrap {
      .btn {
        width: 200px;
        height: 58px;
        line-height: 58px;
        border-radius: 6px;
        border: 1px solid #FFFFFF;
        font-size: 22px;
        color: #FFFFFF;
        cursor: pointer;
        text-align: center;
        margin-top: 47px;
      }
    }
  }
}
.block-p01 {
  background: #fff;
}
.block-p02 {
  background: #F7FDFF;
}
.content-01 {
  width: 1171px;
  margin: 59px auto;
}
.content-02 {
  width: 1220px;
  margin: 50px auto;
  display: flex;
  justify-content: space-around;
  .item {
    display: block;
    width: 393px;
  }
}
.content-03 {
  width: 1200px;
  margin: 60px auto 0;
  .item {
    display: flex;
    justify-content: space-around;
    .item-lf {
      width: 600px;
      text-align: left;
    }
    .line {
      width: 20px;
      height: 3px;
      background: #3986FF;
      margin: 25px 0;
    }
    .name {
      color: #595961;
      font-size: 32px;
      font-weight: 600;
    }
    .font {
      color: #333;
      font-size: 24px;
      font-weight: 300;
    }
  }
  .odd {
    .item-lf {
      margin-right: 143px;
      margin-left: 0;
    }
  }
  .even {
    .item-lf {
      margin-left: 143px;
      margin-right: 0;
    }
  }
}
</style>
